










































































































































































































import {
  Component,
  Vue,
} from 'vue-property-decorator';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCcMastercard } from '@fortawesome/free-brands-svg-icons/faCcMastercard';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';
import { faClipboardList } from '@fortawesome/free-solid-svg-icons/faClipboardList';
import { faShippingFast } from '@fortawesome/free-solid-svg-icons/faShippingFast';
import { faMoneyCheckAlt } from '@fortawesome/free-solid-svg-icons/faMoneyCheckAlt';

import assert from 'assert';
import bButton from 'bootstrap-vue/es/components/button/button';
import bCol from 'bootstrap-vue/es/components/layout/col';
import bContainer from 'bootstrap-vue/es/components/layout/container';
import bImg from 'bootstrap-vue/es/components/image/img';
import bListGroup from 'bootstrap-vue/es/components/list-group/list-group';
import bListGroupItem from 'bootstrap-vue/es/components/list-group/list-group-item';
import bRow from 'bootstrap-vue/es/components/layout/row';

import {
  Address,
  DraftFulfillment,
} from '@/models';

import FullscreenModal from '@/components/FullscreenModal.vue';
import PriceBlock from '@/components/PriceBlock.vue';
import PrimaryButton from '@/components/PrimaryButton.vue';
import QuantityInput from '@/components/QuantityInput.vue';

import CheckoutView from './CheckoutView';
import MobileFulfillmentSelectionForm from './MobileFulfillmentSelectionForm.vue';
import OrderSummary from './OrderSummary.vue';
import PromotionalCodesForm from './PromotionalCodesForm.vue';

@Component({
  components: {
    FontAwesomeIcon,
    FullscreenModal,
    MobileFulfillmentSelectionForm,
    OrderSummary,
    PriceBlock,
    PrimaryButton,
    PromotionalCodesForm,
    QuantityInput,

    bButton,
    bCol,
    bContainer,
    bImg,
    bListGroup,
    bListGroupItem,
    bRow,
  },
})
export default class MobileCheckoutView extends CheckoutView {
  public readonly faCcMastercard = faCcMastercard;
  public readonly faChevronRight = faChevronRight;
  public readonly faClipboardList = faClipboardList;
  public readonly faShippingFast = faShippingFast;
  public readonly faMoneyCheckAlt = faMoneyCheckAlt;

  get onlyOneFulfillment() {
    return !!this.order && (this.order.fulfillments.length === 1);
  }

  public showFulfillmentSelectionModal(fulfillment: DraftFulfillment) {
    this.$root.$emit('show::fullscreen::modal', 'mobile-fulfillment-selection-modal', {
      fulfillment,
    });
  }

  public closeFulfillmentSelectionModal() {
    this.$root.$emit('hide::fullscreen::modal', 'mobile-fulfillment-selection-modal');
  }

  public async selectFulfillment(data: {
    fulfillment: DraftFulfillment,
    selected: string,
    selectedAddress?: Address,
  }) {
    const fulfillmentIdx = this.order!.fulfillments.findIndex((f) => (f === data.fulfillment));
    assert.ok(fulfillmentIdx >= 0, 'no such fulfillment');
    await this.setFulfillment(fulfillmentIdx, data);
    // Close modal.
    this.closeFulfillmentSelectionModal();
  }
}

